import { useEffect } from 'react'
import { Button } from 'react-aria-components'
import { useNavigate } from 'react-router'
import { requestNotificationsPermission } from '../firebase'

export default function Permissions () {
  const navigate = useNavigate()

  const notificationsNotSupported = typeof (Notification) === 'undefined'

  useEffect(() => {
    if (!notificationsNotSupported && Notification.permission === 'granted') {
      navigate('/game')
    }
  }, [navigate, notificationsNotSupported])

  const onPress = () => {
    requestNotificationsPermission().then((permissions) => {
      if (permissions === 'granted') {
        window.location.reload()
      }
    })
  }
  return (
    <div>
      <div>
        Please grant this app permissions to send you notiifications.
      </div>
      <div>
        <Button onPress={onPress} active={!notificationsNotSupported} className='mt-4 p-1 hover:bg-green-200 outline-black border-solid border rounded-sm'>
          Grant Notifications Permission
        </Button>
      </div>
    </div>
  )
}
